import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import elementLocale from 'element-ui/lib/locale';

Vue.use(VueI18n);

const locale = localStorage.getItem('locale') || process.env.DEFAULT_LANGUAGE;
const promises = [];
const messages = {};

// element-ui localization, fix locale mapping
let elementUiLocale = locale;

if (elementUiLocale === 'ru') {
  elementUiLocale = 'ru-RU';
} else if (elementUiLocale === 'et') {
  elementUiLocale = 'ee';
}

import(`element-ui/lib/locale/lang/${elementUiLocale}`).then((lang) => {
  elementLocale.use(lang.default);
});

_.each(process.env.LANGUAGES, (language) => {
  const q = import(/* webpackMode: "lazy-once" */ `./${language}.json`).then((module) => {
    messages[language] = module;
  });
  promises.push(q);
});

// instead of instance we return promise which will be resolved when all language bundles are loaded
export default Promise.all(promises).then(() =>
  new VueI18n({
    locale,
    fallbackLang: ('en'),
    messages,
  }),
);



// WEBPACK FOOTER //
// ./src/i18n/index.js